import React from 'react';
import { ConvertForm } from '../../Containers';
import { Repository } from '../../Components';

const HomeComponent = () => {
  return (
    <div>
      <ConvertForm />
      <Repository />
    </div>
  );
};

export default HomeComponent;